import { isBrowser } from '@sbt-web/utils';

type OnLoadCompleteCallback = (isLoaded: boolean) => void;

const loadHereCode = async (
  onLoadComplete: OnLoadCompleteCallback
): Promise<void> => {
  // If rendered server-side, do not allow the loading and rendering.
  if (!isBrowser()) {
    return;
  }

  if (window.H != undefined) {
    onLoadComplete(true);
    return;
  }

  import(
    /*webpackIgnore: true*/ `${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/static/here-maps/here-sdk-313011.js`
  )
    .then(() => {
      onLoadComplete(true);
    })
    .catch(() => {
      console.error('Unable to load HERE maps code.');
      onLoadComplete(false);
    });
};

export default loadHereCode;
